import { Injectable } from '@angular/core';
import { DatePipe } from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class DateService {
  constructor(private readonly datePipe: DatePipe) { }

  formatElectionDate(date: Date): string {
    const electionDate = this.datePipe.transform(date, 'EEEE \'d.\' d. LLLL');
    return (electionDate?.charAt(0).toUpperCase() ?? '') + (electionDate?.slice(1) ?? '');
  }
}

